/**
 * Schema version for message DSL programs and cache keys.
 * Bump when node shapes or semantics change.
 */
export const LOCALIZATION_SCHEMA_VERSION = 1

/** @type {readonly string[]} */
export const DSL_NODE_TYPES = Object.freeze(["text", "value", "plural", "vocabPlural", "select", "element"])

/** Allowed element tags for `element` nodes */
export const ALLOWED_ELEMENT_TAGS = Object.freeze(["strong", "em", "a", "br", "b", "i", "u"])

/** Allowed attributes per tag */
export const ALLOWED_ELEMENT_ATTRS = Object.freeze({
    strong: [],
    em: [],
    a: ["href", "target", "rel"],
    br: [],
    b: [],
    i: [],
    u: [],
})

/** Shorthand tag aliases — maps template shorthand to semantic HTML */
export const TAG_ALIASES = Object.freeze({
    b: "strong",
    i: "em",
})
